import Address from '__core/shared/model/address/Address';
import stAddress from './address.component';

export default angular
  .module('st.Address', ['st.Core', 'st.Core.GoogleMaps', 'vsGoogleAutocomplete'])
  .factory('Address', () => Address)
  .component('stAddress', stAddress)
  .constant('ADDRESS', {
    STATES: [
      { id: '', value: 'Select one', weight: 1 },
      { id: 'ACT', value: 'Australian Capital Territory', weight: 2 },
      { id: 'NSW', value: 'New South Wales', weight: 3 },
      { id: 'NT', value: 'Northern Territory', weight: 4 },
      { id: 'QLD', value: 'Queensland', weight: 5 },
      { id: 'SA', value: 'South Australia', weight: 6 },
      { id: 'TAS', value: 'Tasmania', weight: 7 },
      { id: 'VIC', value: 'Victoria', weight: 8 },
      { id: 'WA', value: 'Western Australia', weight: 9 }
    ],
    STREET_TYPES: {
      AU: [
        { value: 'Access' },
        { value: 'Alley' },
        { value: 'Alleyway' },
        { value: 'Amble' },
        { value: 'Anchorage' },
        { value: 'Approach' },
        { value: 'Arcade' },
        { value: 'Arterial' },
        { value: 'Artery' },
        { value: 'Avenue' },
        { value: 'Banan' },
        { value: 'Bank' },
        { value: 'Basin' },
        { value: 'Bay' },
        { value: 'Beach' },
        { value: 'Bend' },
        { value: 'Block' },
        { value: 'Boardwalk' },
        { value: 'Boulevard' },
        { value: 'Boulevarde' },
        { value: 'Bowl' },
        { value: 'Brace' },
        { value: 'Brae' },
        { value: 'Break' },
        { value: 'Bridge' },
        { value: 'Broadway' },
        { value: 'Brow' },
        { value: 'Bypass' },
        { value: 'Byway' },
        { value: 'Canal' },
        { value: 'Causeway' },
        { value: 'Centre' },
        { value: 'Centreway' },
        { value: 'Chase' },
        { value: 'Circle' },
        { value: 'Circlet' },
        { value: 'Circuit' },
        { value: 'Circus' },
        { value: 'Close' },
        { value: 'Cluster' },
        { value: 'Colonnade' },
        { value: 'Common' },
        { value: 'Concourse' },
        { value: 'Connection' },
        { value: 'Copse' },
        { value: 'Corner' },
        { value: 'Corso' },
        { value: 'Course' },
        { value: 'Court' },
        { value: 'Courtyard' },
        { value: 'Cove' },
        { value: 'Crescent' },
        { value: 'Crest' },
        { value: 'Cross' },
        { value: 'Crossing' },
        { value: 'Crossroad' },
        { value: 'Crossway' },
        { value: 'Cruiseway' },
        { value: 'Cul-De-Sac' },
        { value: 'Cutting' },
        { value: 'Dale' },
        { value: 'Dell' },
        { value: 'Dene' },
        { value: 'Deviation' },
        { value: 'Dip' },
        { value: 'Distributor' },
        { value: 'Divide' },
        { value: 'Dock' },
        { value: 'Domain' },
        { value: 'Drive' },
        { value: 'Driveway' },
        { value: 'Edge' },
        { value: 'Elbow' },
        { value: 'End' },
        { value: 'Entrance' },
        { value: 'Esplanade' },
        { value: 'Estate' },
        { value: 'Estuary' },
        { value: 'Expressway' },
        { value: 'Extension' },
        { value: 'Fairway' },
        { value: 'Fire Track' },
        { value: 'Firebreak' },
        { value: 'Fireline' },
        { value: 'Firetrack' },
        { value: 'Firetrail' },
        { value: 'Flat' },
        { value: 'Follow' },
        { value: 'Footway' },
        { value: 'Ford' },
        { value: 'Foreshore' },
        { value: 'Formation' },
        { value: 'Freeway' },
        { value: 'Front' },
        { value: 'Frontage' },
        { value: 'Gap' },
        { value: 'Garden' },
        { value: 'Gardens' },
        { value: 'Gate' },
        { value: 'Gates' },
        { value: 'Gateway' },
        { value: 'Glade' },
        { value: 'Glen' },
        { value: 'Grange' },
        { value: 'Green' },
        { value: 'Ground' },
        { value: 'Grove' },
        { value: 'Gully' },
        { value: 'Harbour' },
        { value: 'Heath' },
        { value: 'Heights' },
        { value: 'Highroad' },
        { value: 'Highway' },
        { value: 'Hill' },
        { value: 'Hollow' },
        { value: 'Hub' },
        { value: 'Interchange' },
        { value: 'Intersection' },
        { value: 'Junction' },
        { value: 'Key' },
        { value: 'Keys' },
        { value: 'Landing' },
        { value: 'Lane' },
        { value: 'Laneway' },
        { value: 'Lees' },
        { value: 'Line' },
        { value: 'Link' },
        { value: 'Little' },
        { value: 'Lookout' },
        { value: 'Loop' },
        { value: 'Lower' },
        { value: 'Mall' },
        { value: 'Manor' },
        { value: 'Meander' },
        { value: 'Mears' },
        { value: 'Mew' },
        { value: 'Mews' },
        { value: 'Mile' },
        { value: 'Motorway' },
        { value: 'Mount' },
        { value: 'Nook' },
        { value: 'Outlet' },
        { value: 'Outlook' },
        { value: 'Parade' },
        { value: 'Park' },
        { value: 'Parklands' },
        { value: 'Parkway' },
        { value: 'Part' },
        { value: 'Pass' },
        { value: 'Path' },
        { value: 'Pathway' },
        { value: 'Piazza' },
        { value: 'Pier' },
        { value: 'Place' },
        { value: 'Plateau' },
        { value: 'Plaza' },
        { value: 'Pocket' },
        { value: 'Point' },
        { value: 'Port' },
        { value: 'Portal' },
        { value: 'Promenade' },
        { value: 'Pursuit' },
        { value: 'Quad' },
        { value: 'Quadrangle' },
        { value: 'Quadrant' },
        { value: 'Quay' },
        { value: 'Quays' },
        { value: 'Ramble' },
        { value: 'Ramp' },
        { value: 'Range' },
        { value: 'Reach' },
        { value: 'Reserve' },
        { value: 'Rest' },
        { value: 'Retreat' },
        { value: 'Return' },
        { value: 'Ride' },
        { value: 'Ridge' },
        { value: 'Ridgeway' },
        { value: 'Right Of Way' },
        { value: 'Ring' },
        { value: 'Rise' },
        { value: 'Rising' },
        { value: 'River' },
        { value: 'Riverway' },
        { value: 'Riviera' },
        { value: 'Road' },
        { value: 'Roads' },
        { value: 'Roadside' },
        { value: 'Roadway' },
        { value: 'Ronde' },
        { value: 'Rosebowl' },
        { value: 'Rotary' },
        { value: 'Round' },
        { value: 'Route' },
        { value: 'Row' },
        { value: 'Rue' },
        { value: 'Run' },
        { value: 'Service Way' },
        { value: 'Shunt' },
        { value: 'Siding' },
        { value: 'Slope' },
        { value: 'Sound' },
        { value: 'Spur' },
        { value: 'Square' },
        { value: 'Stairs' },
        { value: 'State Highway' },
        { value: 'Steps' },
        { value: 'Strand' },
        { value: 'Street' },
        { value: 'Streets' },
        { value: 'Strip' },
        { value: 'Subway' },
        { value: 'Tarn' },
        { value: 'Tarnice Way' },
        { value: 'Terrace' },
        { value: 'Thoroughfare' },
        { value: 'Throughway' },
        { value: 'Tollway' },
        { value: 'Top' },
        { value: 'Tor' },
        { value: 'Towers' },
        { value: 'Track' },
        { value: 'Trail' },
        { value: 'Trailer' },
        { value: 'Triangle' },
        { value: 'Trunkway' },
        { value: 'Turn' },
        { value: 'Twist' },
        { value: 'Underpass' },
        { value: 'Upper' },
        { value: 'Vale' },
        { value: 'Viaduct' },
        { value: 'View' },
        { value: 'Villas' },
        { value: 'Vista' },
        { value: 'Wade' },
        { value: 'Walk' },
        { value: 'Walkway' },
        { value: 'Waterway' },
        { value: 'Way' },
        { value: 'Wharf' },
        { value: 'Woods' },
        { value: 'Wynd' },
        { value: 'Yard' }
      ]
    }
  });
